import { useShallow } from 'zustand/react/shallow';
import { useTreeStore } from '../store/TreeStore';

export function useGetPreviousStep(position?: number) {
  const containerLookup = useTreeStore(useShallow(state => Object.values(state.containerLookup)));
  if (position === undefined) return undefined;
  return containerLookup.find(container => container.stepPosition !== undefined && container.stepPosition === position - 1 && !container.container.isScaffold);
}
